import React, { useEffect, useState, useRef, useContext } from "react";
import {
  Table,
  TableBody,
  alpha,
  FormControl,
  TableRow,
  TableCell,
  Paper,
  makeStyles,
  Button,
  Box,
  Menu,
  Checkbox,
  Select,
  MenuItem,
  InputLabel,
  Tooltip,
  TableContainer,
  InputAdornment,
  Grid,
  useTheme,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SearchIcon from "@material-ui/icons/Search";
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import { getCompliance } from "../../store/action";
import FilterListIcon from "@material-ui/icons/FilterList";
import axios from "axios";
import apiConfigs from "../../config/config";
import { TextField } from "@mui/material";
import { getStaffDetail } from "../../store/action/staff/staffAction";
import {
  createFilter,
  deleteFilter,
} from "../../store/action/booking/bookingAction";
import { getFilterData } from "../../store/action/signee/signeeAction";
import EnhancedTableHead from "./EnhancedTableHead";
import { headCells } from "./Headcells";
import { useGooglePlaceAutoCompleteForCandidate } from "../../components/GoogleAPI/google_place_autocomplete";
import { notificationSuccess } from "../../store/action/notificationMsg";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import moment from "moment";
import { customEnLocale } from "../../helper/customLocale";
import TruncateText from "../../components/TruncateText";
import Loading from "../../components/Loading/Loading";
import TablePaginationControls from "../../components/TablePaginationControls";
import { Link as RouterLink } from 'react-router-dom'; // Alias for React Router's Link
import MuiLink from '@mui/material/Link';
import history from "../../utils/HistoryUtils";
import { ThemeContext } from "../../App";
const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    // overflowX: "auto",
    padding: 20,
    background: theme.palette.background.main
  },
  container: {
    marginTop: "15px",
    maxHeight: "calc(100vh - 260px)",
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: "100%",
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(),
      width: "auto",
    },
  },
  searchIcon: {
    width: theme.spacing(6),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
    width: "100%",
  },
  formControl: {
    width: "100%",
  },
  formControl1: {
    width: 120,
  },
  filterBox: {
    padding: 8,
  },
  radioGroup: {
    flexDirection: "row",
  },
}));

const ComplianceDocument = ({ match }) => {
  const theme = useTheme();
  const classes = useStyle();
  const dispatch = useDispatch();
  const { getComplianceItem, loading, getVCFilterDataSuccess } = useSelector(
    (state) => state.compliance
  );
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(15);
  const [searchPage, setSearchPage] = useState(1);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [complianceId, setComplianceId] = useState([]);
  useEffect(() => {
    // Calculate default start and end dates
    const today = new Date();
    const defaultStartDate = new Date(
      today.getTime() - 15 * 24 * 60 * 60 * 1000
    ); // Today - 15 days
    const defaultEndDate = new Date(today.getTime() + 15 * 24 * 60 * 60 * 1000); // Today + 15 days
    const formatDate = (date) => {
      const day = String(date.getDate()).padStart(2, '0'); // Get day and pad with 0 if needed
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month (0-indexed)
      const year = date.getFullYear(); // Get full year
      return `${day}-${month}-${year}`; // Return formatted date
    };
    const formattedDate = formatDate(defaultStartDate);
    // Set default dates
    setStartDate(formattedDate);
    setEndDate(defaultEndDate);
  }, []);

  const [searchData, setSearchData] = useState({
    search: "",
    start_date: "",
    end_date: "",
    module_name: "compliance-document",
  });
  const address1Ref = useRef();
  const googleAutoCompleteSvc = useGooglePlaceAutoCompleteForCandidate();
  let autoComplete = "";
  const handleAddressSelect = async () => {
    let addressObj = await googleAutoCompleteSvc.getFullAddress(autoComplete);
    setSearchData((prevData) => ({
      ...prevData,
      postcode: addressObj.address_line_1,
      latitude: addressObj.latitude,
      longitude: addressObj.longitude,
    }));
  };

  const handleChange = (event) => {
    async function loadGoogleMaps() {
      // initialize the Google Place Autocomplete widget and bind it to an input element.
      // eslint-disable-next-line
      autoComplete = await googleAutoCompleteSvc.initAutoComplete(
        address1Ref.current,
        handleAddressSelect
      );
    }
    loadGoogleMaps();
    setSearchData({ ...searchData, [event.target.name]: event.target.value });
  };

  let staffDetail = JSON.parse(localStorage.getItem("staffDetail"));

  staffDetail = staffDetail && staffDetail.replace(/['"]+/g, "");
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("candidate_name");

  const handleSearchChange = (event) => {
    const d1 = event.target.value;
    if (d1) {
      setTimeout(
        getComplianceList(
          searchPage,
          d1,
          searchData?.start_date ? moment(searchData?.start_date).format("DD-MM-yyyy") : startDate,
          searchData?.end_date ? moment(searchData?.end_date).format("DD-MM-yyyy") : endDate
        ),
        100
      );
    } else {
      setTimeout(
        getComplianceList(
          page,
          perPage,
          "",
          searchData?.start_date ? moment(searchData?.start_date).format("DD-MM-yyyy") : startDate,
          searchData?.end_date ? moment(searchData?.end_date).format("DD-MM-yyyy") : endDate
        ),
        100
      );
      setSearchPage(1);
    }
    setSearchData({ ...searchData, [event.target.name]: event.target.value });
  };

  const handleMenu = (event) => {
    if (searchData.search === "") {
      getFilterDataByModule();
    }
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleClickSearch = (event, value) => {
    setTimeout(
      getComplianceList(
        page,
        perPage,
        searchData?.search ? searchData?.search : getVCFilterDataSuccess?.data?.search,
        "",
        "",
        searchData?.start_date ? moment(searchData?.start_date).format("DD-MM-yyyy") : startDate,
        searchData?.end_date ? moment(searchData?.end_date).format("DD-MM-yyyy") : endDate,
        statusFilter,
        complianceFilter,
      ),
      1000
    );
    handleMenuClose(true);
  };

  const getComplianceList = (
    pageNo = 1,
    perPage = 15,
    search = "",
    type = order,
    column_name = orderBy,
    start_date = "",
    end_date = "",
    status = "",
    complianceFilter = "",
  ) => {
    // let tempData = []
    dispatch(
      getCompliance({
        pageNo,
        perPage,
        search,
        type,
        column_name,
        start_date,
        end_date,
        status,
        complianceFilter,
      })
    );
  };

  const [staff, setStaff] = useState([]);
  const [statusFilter, setStatusFilter] = useState("");
  const [complianceFilter, setComplianceFilter] = useState("");
  const loginUserInfo = JSON.parse(
    window.localStorage.getItem("loginUserInfo")
  );

  const getStaff = async () => {
    dispatch(
      getStaffDetail((result) => {
        if (result?.data) {
          setStaff(result);
        }
      })
    );
  };

  const onhandlClick1 = (id) => {
    history.push(`/admin/candidate/${id}/detail`);
  };
  const onhandlClick = async (id) => {
    const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
    let formData = {
      id: id,
    };
    await axios
      .post(
        `${apiConfigs.API_URL}api/organization/send-mail-to-candidate`,
        formData,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${loggedInUser}`,
          },
        }
      )
      .then((response) => {
        getComplianceList(
          page,
          "",
          order,
          orderBy,
          moment(startDate).format("DD-MM-yyyy"),
          moment(endDate).format("DD-MM-yyyy")
        );
        dispatch(notificationSuccess("Reminder Sent Succesfully"));
      })
      .catch((error) => {
        console.log("error.message", error.message);
      });
  };

  const handleChangePage = (event, value) => {
    setPage(value);
    setTimeout(
      getComplianceList(
        value,
        perPage,
        searchData?.search ? searchData?.search : getVCFilterDataSuccess?.data?.search,
        "",
        "",
        searchData?.start_date ? moment(searchData?.start_date).format("DD-MM-yyyy") : moment(startDate).format("DD-MM-yyyy"),
        searchData?.end_date ? moment(searchData?.end_date).format("DD-MM-yyyy") : endDate
      ),
      2000
    );
  };

  const handlePerPageChange = (event) => {
    const newPerPage = event.target.value;
    setPerPage(newPerPage);
    setPage(1);
    getComplianceList(
      1,
      newPerPage,
      searchData?.search ? searchData?.search : getVCFilterDataSuccess?.data?.search,
      "",
      "",
      searchData?.start_date ? moment(searchData?.start_date).format("DD-MM-yyyy") : moment(startDate).format("DD-MM-yyyy"),
      searchData?.end_date ? moment(searchData?.end_date).format("DD-MM-yyyy") : endDate
    )
  };

  const handleReset = () => {
    let data = {
      search: "",
      module_name: "compliance-document",
    };
    setSearchData(data);
    handleMenuClose(true);
    setTimeout(getComplianceList(page, "", ""), 100);
    dispatch(deleteFilter(data, "compliance-document"));
  };

  const getFilterDataByModule = () => {
    let data = {
      search: "",
      module_name: "compliance-document",
    };
    dispatch(getFilterData("compliance-document"));
    if (getVCFilterDataSuccess?.data) {
      if (getVCFilterDataSuccess?.data?.status !== "") {
        data.status = getVCFilterDataSuccess?.data?.status;
      }
      if (getVCFilterDataSuccess?.data?.specialty !== "") {
        data.specialty = getVCFilterDataSuccess?.data?.specialty;
      }
      if (getVCFilterDataSuccess?.data?.postcode !== "") {
        data.postcode = getVCFilterDataSuccess?.data?.postcode;
      }
      if (getVCFilterDataSuccess?.data?.consultants !== "") {
        data.consultants = getVCFilterDataSuccess?.data?.consultants;
      }
      if (getVCFilterDataSuccess?.data?.compliance !== "") {
        data.compliance = getVCFilterDataSuccess?.data?.compliance;
      }
      setSearchData(data);
    }
  };

  const handleClickSave = async () => {
    dispatch(createFilter(searchData, "compliance-document"));
    setPage(1);
    getComplianceList(
      1,
      searchData?.search
        ? searchData?.search
        : getVCFilterDataSuccess?.data?.search,

      order,
      orderBy
    );
    handleMenuClose(true);
  };

  useEffect(() => {
    if (startDate) {
      setSearchData({
        ...searchData,
        start_date: startDate,
      });
    }
  }, [startDate]);

  useEffect(() => {
    if (endDate) {
      setSearchData({
        ...searchData,
        end_date: endDate,
      });
    }
  }, [endDate]);

  const handleRequestSort = (
    property,
    setOrder,
    setOrderBy,
    orderBy,
    order
  ) => {
    const isAsc = orderBy === property && order === "ASC";
    setOrder(isAsc ? "DESC" : "ASC");
    setOrderBy(property);
  };

  useEffect(() => {
    const today = new Date();
    const defaultStartDate = new Date(
      today.getTime() - 15 * 24 * 60 * 60 * 1000
    ); // Today - 15 days
    const defaultEndDate = new Date(today.getTime() + 15 * 24 * 60 * 60 * 1000);
    if (searchData || getVCFilterDataSuccess?.data) {
      getComplianceList(
        1,
        searchData?.search
          ? searchData?.search
          : getVCFilterDataSuccess?.data?.search,
        order,
        orderBy,
        searchData?.start_date
          ? moment(searchData?.start_date).format("DD-MM-yyyy")
          : moment(defaultStartDate).format("DD-MM-yyyy"),
        searchData?.end_date
          ? moment(searchData?.end_date).format("DD-MM-yyyy")
          : moment(defaultEndDate).format("DD-MM-yyyy")
      );
    }
  }, [getVCFilterDataSuccess?.data, order, orderBy]);

  const handleCheckboxClick = (event, ids) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      // Add the id to the checkedIds array
      setComplianceId((prevCheckedIds) => [...prevCheckedIds, ids]);
    } else {
      // Remove the id from the checkedIds array
      setComplianceId((prevCheckedIds) => prevCheckedIds.filter((complianceId) => complianceId !== ids));
    }
  }

  const sendReminderToselectedPerson = async () => {
    const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
    let formData = {
      id: complianceId,
    };
    await axios
      .post(
        `${apiConfigs.API_URL}api/organization/send-mail-to-candidate`,
        formData,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${loggedInUser}`,
          },
        }
      )
      .then((response) => {
        dispatch(notificationSuccess("Reminder Sent Succesfully"));
        getComplianceList(
          page,
          "",
          order,
          orderBy,
          moment(startDate).format("DD-MM-yyyy"),
          moment(endDate).format("DD-MM-yyyy")
        );
        setComplianceId([]);
      })
      .catch((error) => {
        console.log("error.message", error.message);
      });
  };
  const handleCheckboxAllClick = (event) => {
    const isChecked = event.target.checked;
    if (isChecked && getComplianceItem?.data?.data?.length > 0) {
      const allid = getComplianceItem?.data.data.map((row, index) => {
        return row.id;
      });
      setComplianceId(allid);
    } else {
      setComplianceId([]);
    }
  }

  function capitalizeStatus(status) {
    if (!status) return "-";
    return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
  }
  const { mode } = useContext(ThemeContext);
  useEffect(() => {
    document.documentElement.style.setProperty('--bg-color', theme.palette.grey[1000]);
    document.documentElement.style.setProperty('--sticky-header', theme.palette.thead);
    document.documentElement.style.setProperty('--sticky-odd', theme.palette.background.stickyOdd);
    document.documentElement.style.setProperty('--sticky-even', theme.palette.background.stickyEven);
  }, [mode]);



  return (
    <>
      {loading && <Loading open={loading} />}

      <Paper className={`${classes.root} mb-6`}>
        <Box display="flex" alignItems="center" justifyContent="flex-end">
          {/* <Box sx={{ display: "flex", alignItems: "center", width: "24%" }}>

            <div className={classes.search}>
              <TextField
                size="small"
                placeholder="Search ..."
                variant="outlined"
                name="search"
                onChange={handleSearchChange}
                onKeyPress={(e) => e.key === "Enter" && handleClickSearch()}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon
                        style={{
                          color: "#856f6f", // Icon color
                          cursor: "pointer",
                        }}
                        onClick={handleClickSearch}
                      />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          </Box> */}
          <Box display="flex" alignItems="end">
            {complianceId?.length > 0 && (
              <span style={{ marginTop: "5px" }}>{complianceId.length} Record Selected</span>
            )}
            {complianceId?.length > 0 && (
              <div className="ml-5">
                <Button
                  style={{ marginRight: "15px" }}
                  variant="contained"
                  color="primary"
                  onClick={sendReminderToselectedPerson}
                >
                  Send Reminder (All)
                </Button>
              </div>
            )}
            <TextField
              size="small"
              placeholder="Search ..."
              variant="outlined"
              name="search"
              onChange={handleSearchChange}
              onKeyPress={(e) => e.key === "Enter" && handleClickSearch()}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon
                      style={{
                        color: "#856f6f", // Icon color
                        cursor: "pointer",
                      }}
                      onClick={handleClickSearch}
                    />
                  </InputAdornment>
                ),
              }}
              className="modernSearchField"
            />
            <Tooltip title="Filters">
              <Button onClick={handleMenu}>
                <FilterListIcon />
              </Button>
            </Tooltip>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              open={openMenu}
              getContentAnchorEl={null}
              onClose={handleMenuClose}
              className="filterBookingSearch"
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
              <Box className="customPopup">
                {/* <Box className={classes.filterBox}> */}
                {/* Date Range */}
                <Grid container spacing={2} mb={2}>
                  <Grid item xs={6}>
                    <LocalizationProvider
                      dateAdapter={AdapterDateFns}
                      adapterLocale={customEnLocale}
                    >
                      <DatePicker
                        label="Start Date"
                        // inputFormat="dd/MM/yyyy"
                        inputFormat="dd-MMM-yyyy"
                        value={startDate || null}
                        onChange={(newValue) => setStartDate(newValue)}
                        renderInput={(params) => (
                          <TextField {...params} fullWidth variant="outlined" />
                        )}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={6}>
                    <LocalizationProvider
                      dateAdapter={AdapterDateFns}
                      adapterLocale={customEnLocale}
                    >
                      <DatePicker
                        label="End Date"
                        // inputFormat="dd/MM/yyyy"
                        inputFormat="dd-MMM-yyyy"
                        value={endDate || null}
                        onChange={(newValue) => setEndDate(newValue)}
                        renderInput={(params) => (
                          <TextField {...params} fullWidth variant="outlined" />
                        )}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>

                {/* Filters */}
                <Grid container spacing={2} mb={2}>
                  <Grid item xs={6}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel>Status</InputLabel>
                      <Select
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                        label="Status"
                      >
                        <MenuItem value="PENDING">PENDING</MenuItem>
                        <MenuItem value="SUCCESS">SUCCESS</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel>Compliance Status</InputLabel>
                      <Select
                        value={complianceFilter}
                        onChange={(e) => setComplianceFilter(e.target.value)}
                        label="Compliance Status"
                      >
                        <MenuItem value="">Select Compliance Status</MenuItem>
                        <MenuItem value="Active">Active</MenuItem>
                        <MenuItem value="Not active">Not active</MenuItem>
                        <MenuItem value="Pre reg">Pre reg</MenuItem>
                        <MenuItem value="New sign up">New sign up</MenuItem>
                        <MenuItem value="Archive">Archive</MenuItem>
                        <MenuItem value="Do not use">Do not use</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>

                {/* Search Button */}
                <Box display="flex" justifyContent="flex-end">
                  <Button
                    variant="contained"
                    color="secondary"
                    className={classes.searchIcondet}
                    onClick={handleClickSearch}
                  >
                    Search
                  </Button>
                </Box>
              </Box>
              {/* </Box> */}
            </Menu>

          </Box>
        </Box>
        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table">
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              handleCheckboxAllClick={handleCheckboxAllClick}
              onRequestSort={(event, property) => {
                handleRequestSort(
                  property,
                  setOrder,
                  setOrderBy,
                  orderBy,
                  order
                );
              }}
              allId={complianceId?.length}
              rowCount={getComplianceItem?.data?.data?.length}
              headCells={headCells[0]}
            />

            <TableBody>
              {getComplianceItem?.data &&
                getComplianceItem?.data?.data.map((list, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell scope="row" className="stickyCell stickyFirst">
                        <Checkbox
                          value={list.id}
                          checked={complianceId?.includes(list.id)}
                          onClick={(event) =>
                            handleCheckboxClick(event, list.id)
                          }
                          style={{ color: theme.palette.listItem }}
                          className="selectCheckbox"
                        />
                      </TableCell>
                      <TableCell scope="row" className="stickyCell stickySecond" style={{ width: 80, color: theme.palette.listItem }}>
                        {index + 1}
                      </TableCell>
                      <TableCell align="left" className="stickyCell stickyName" style={{ width: 70, }}>
                        <MuiLink
                          component={RouterLink}
                          to="#"
                          onClick={(e) => {

                            e.preventDefault();
                            onhandlClick1(list?.get_user?.id);

                          }}
                          underline="hover"
                          sx={{
                            cursor: "pointer",
                            color: "#3e81c3"
                          }}
                        >
                          {/* {list.first_name} */}
                          {list?.get_user?.first_name} {list?.get_user?.last_name}
                        </MuiLink>
                      </TableCell>
                      <TableCell align="left" style={{ width: 70, color: theme.palette.listItem }}>
                        {list?.get_user?.status}
                      </TableCell>
                      <TableCell align="left" style={{ minWidth: 300, color: theme.palette.listItem }}>
                        {list?.sub_category?.get_docs_type?.get_category?.title}
                      </TableCell>
                      <TableCell align="left" style={{ minWidth: 300, color: theme.palette.listItem }}>
                        <TruncateText text={list?.sub_category?.title} maxLength={20} />
                      </TableCell>
                      <TableCell align="left" style={{ width: 200, color: theme.palette.listItem }}>
                        {list?.file_name}
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{ width: 50, color: theme.palette.listItem }}
                      >
                        {list?.formatted_expire_date
                          ? moment(list.formatted_expire_date, "DD-MM-YYYY").format("DD-MMM-YYYY")
                          : "-"}
                      </TableCell>
                      <TableCell align="left" style={{ width: 50, color: theme.palette.listItem }}>
                        {list?.remark}
                      </TableCell>
                      <TableCell align="left" style={{ width: 50, color: theme.palette.listItem }}>
                        {capitalizeStatus(list?.document_status)}
                      </TableCell>
                      <TableCell align="left" style={{ width: 50, color: theme.palette.listItem }}>
                        {list.last_notified ? moment(list.last_notified).format("DD-MMM-YYYY").toUpperCase() : "-"}
                        {/* {list.last_notified
                          ? `${new Date(list.last_notified).getDate()}-${new Date(list.last_notified).getMonth() + 1
                          }-${new Date(list.last_notified).getFullYear()}`
                          : "-"} */}
                      </TableCell>
                      <TableCell align="center" className="stickyCell stickyAction" style={{ width: 70, color: theme.palette.listItem }}>
                        <Tooltip title="Send Reminder" arrow>
                          <Link
                            to="#"
                            className="btn-send-reminder secondary"
                            onClick={(e) => onhandlClick(list.id)}
                          >
                            <NotificationsActiveIcon fontSize="small" style={{ color: "#1c487a" }} />
                          </Link>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  );
                })}
              {(getComplianceItem?.data?.data?.length === 0 || getComplianceItem?.length === 0) && (
                <TableCell scope="row" colSpan="15">
                  <div className="" align="center">
                    Sorry no record available
                  </div>
                </TableCell>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePaginationControls
          page={page}
          rowsPerPage={perPage}
          totalRecords={getComplianceItem?.data?.total}
          onPageChange={handleChangePage}
          handlePerPageChange={handlePerPageChange}
        />
      </Paper >
    </>
  );
};

export default ComplianceDocument;
